import { EDIT_SO_PRODUCT_CART_CONTROLS } from './types';

export const editSOProductCartControls = ({ isEdit }) => ({
  type: EDIT_SO_PRODUCT_CART_CONTROLS,
  payload: {
    isEdit
  }
});
